import React from 'react';

import cs from './styles.module.scss';

/** wrapper for shared styles where we want people to add properties,
 * used for a couple different blankstate type pages
 */
export const ManagePropertiesWrapper: React.FunctionComponent<React.PropsWithChildren> = ({
  children,
}) => (
  <div className={cs.pageShellFlexFill}>
    <div className={cs.contentCard}>{children}</div>
  </div>
);
